var BxfDatePickerDateFormatEnum;
(function (BxfDatePickerDateFormatEnum) {
    BxfDatePickerDateFormatEnum["DD_MM_YYYY"] = "DD MM YYYY";
    BxfDatePickerDateFormatEnum["MM_DD_YYYY"] = "MM DD YYYY";
    BxfDatePickerDateFormatEnum["YYYY_MM_DD"] = "YYYY MM DD";
    BxfDatePickerDateFormatEnum["DD_MMM_YYYY"] = "DD MMM YYYY";
    BxfDatePickerDateFormatEnum["MMM_DD_YYYY"] = "MMM DD YYYY";
    BxfDatePickerDateFormatEnum["DD_MMMM_YYYY"] = "DD MMMM YYYY";
    BxfDatePickerDateFormatEnum["MMMM_DD_YYYY"] = "MMMM DD YYYY";
})(BxfDatePickerDateFormatEnum || (BxfDatePickerDateFormatEnum = {}));

var BxfDatePickerSeparatorsEnum;
(function (BxfDatePickerSeparatorsEnum) {
    BxfDatePickerSeparatorsEnum["DASH"] = "-";
    BxfDatePickerSeparatorsEnum["PERIOD"] = ".";
    BxfDatePickerSeparatorsEnum["FORWARD_SLASH"] = "/";
    BxfDatePickerSeparatorsEnum["SPACE"] = " ";
    BxfDatePickerSeparatorsEnum["COMMA"] = ",";
})(BxfDatePickerSeparatorsEnum || (BxfDatePickerSeparatorsEnum = {}));

export { BxfDatePickerDateFormatEnum as B, BxfDatePickerSeparatorsEnum as a };
